import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { GuardTake, GuardTakeStatus } from '../guard-takes.service';
import { FeatureInfoPanelData, FeatureInfoPanelRow } from '../visor.types';

export interface GuardTakeStatusChangeRequest {
  status: GuardTakeStatus;
}

@Component({
  selector: 'app-feature-info-panel',
  templateUrl: './feature-info-panel.component.html',
  styleUrl: './feature-info-panel.component.scss'
})
export class FeatureInfoPanelComponent implements OnChanges {
  @Input({ required: true }) data!: FeatureInfoPanelData;
  @Input() guardTake?: GuardTake;
  @Input() guardTakeStatusSaving = false;
  @Input() guardTakeStatusError = '';

  @Output() closed = new EventEmitter<void>();
  @Output() guardTakeStatusChangeRequested = new EventEmitter<GuardTakeStatusChangeRequest>();

  protected selectedGuardTakeStatus: GuardTakeStatus | '' = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['guardTake']) {
      return;
    }

    this.selectedGuardTakeStatus = '';
  }

  protected close(): void {
    this.closed.emit();
  }

  protected selectGuardTakeStatus(status: GuardTakeStatus): void {
    if (!this.guardTakeStatusSaving && status !== this.guardTake?.status) {
      this.selectedGuardTakeStatus = status;
    }
  }

  protected submitGuardTakeStatus(event: Event): void {
    event.preventDefault();

    if (
      !this.selectedGuardTakeStatus ||
      this.guardTakeStatusSaving ||
      this.selectedGuardTakeStatus === this.guardTake?.status
    ) {
      return;
    }

    this.guardTakeStatusChangeRequested.emit({
      status: this.selectedGuardTakeStatus
    });
  }

  protected getRowIconPath(row: FeatureInfoPanelRow): string {
    switch (row.kind) {
      case 'surface':
        return 'surface';
      case 'take':
        return 'take';
      case 'irrigation-status':
        return 'calendar';
    }
  }

}
